import { useAppContext } from '../../../Services/AppContext';
import Loading from '../../Loading';
import styles from './AntivirusCheck.module.scss';

export default function AntivirusCheck({ inRow = false }) {
	const { translation } = useAppContext();

	return (
		<div className={inRow && styles.displayInRow}>
			<Loading className={inRow && styles.skCircle} />
			<div className={styles.text}>
				{translation['documentation.antivirusInProgress']}
			</div>
		</div>
	);
}
